import React from 'react';
import { IoCloseSharp } from 'react-icons/io5';
import { Controller, useForm } from 'react-hook-form';
import { ReactComponent as CopyCod } from '../../assets/icons/copy-cod.svg';
import { PropsFromRedux } from '.';
import checkImg from '../../assets/images/success-ribbons.svg';
import { USER } from '../../interfaces/auth.interface';
import TextInput from '../form-controls/TextInput';
import { Spinner } from '../Spinners/Spinner';

interface Props extends PropsFromRedux {}

interface Inputs {
    accountno : string;
    username : string;
    password : string;

}

const StellasAccountDetails: React.FC<Props> = ({ 
    hideModal,
    showModal,
    modal,
    user,
    walletShipments,
    stellaState,
    stelladetails
 }) => {
 const userObj: USER = user?.response?.Object;
 const accountRes = stellaState?.response;
 const accountNo = modal?.ownProps?.accountNo;
const closeModal = () => {
    hideModal();
}

// console.log('user details',user);
// console.log('Account No',accountNo)

React.useEffect(() => {
    stelladetails(userObj.UserChannelCode);
},[stelladetails])


const { handleSubmit, control, errors, reset, watch,register, setValue } = useForm<Inputs>({
    // resolver: yupResolver(schema),
    defaultValues: {
        accountno : accountNo,
        username : accountRes?.Object?.UserName,
        password : accountRes?.Object?.Password,
    }
});

// if(stellaState?.loading){
//     return(
//         <div className="flex flex-col items-center justify-center">
//             <Spinner color="#CCC" />
//             <div className="font-medium text-gray-400">
//                 Fetching Account Details...
//             </div>
//         </div>
//     );
// }

return(
    <div className="w-full md:px-24 p-12 bg-white lg:px-20 py-10 relative">
        <button type="button" aria-label="Close" onClick={closeModal}>
            <IoCloseSharp className="sticky sm:absolute cursor-pointer text-2xl top-0 left-full sm:left-auto sm:right-5 sm:top-5" />
        </button>
        {stellaState?.loading &&
            <div className="flex flex-col items-center justify-center">
                  <Spinner color="#CCC" />
                 <div className="font-medium text-gray-400">
                     Fetching Account Details...
                 </div>

             </div>
        }

        {/* <div className="w-full my-2 flex items-center justify-center">
        </div> */}

        {!stellaState?.loading &&
        <div className="w-full">

        {/* {stellaState?.response?.Object?.UserName == "No login details" && 
            <div className="w-full font-medium text-gray-400 text-center p-12">
              No account details available
            </div>
            } */}


        {/* {stellaState?.response?.Object?.UserName !== "No login details" &&  */}
            <div className="w-full">
               <div className="w-full my-6 bg-gray-50 p-4 rounded">
               <h2 className="mb-1 text-lg font-semibold text-black">Stellas App Details.</h2>
               <p className=" text-sm text-gray-500 my-2 mb-6">
               Log in to your stellas app using the below details.</p>

               <div className="w-full flex justify-between my-4">
                   <h5 className="text-gray-400 mr-12">Acc No:</h5>
                   <div className="">
                       
                   <div className="flex text-xs lg:text-sm md:text-sm">
                       <p>{accountNo}</p>
                       <CopyCod className="w-4 font-bold text-black mx-2 cursor-pointer" />
                           <Controller
                               name="accountno"
                               control={control}
                               defaultValue=""
                               render={({ name, value, onChange }) => (
                               <TextInput
                                   name={name}
                                   value={value}
                                   id={name}
                                   showCopy
                                   disabled
                                   className="border-gray-300"
                                   wrapperClassName="absolute -ml-36 opacity-0"
                                   // error={errors['zipcode']}
                                   // label="Zipcode"
                                   labelClassName=""
                                   placeholder=""
                                   customChange={onChange}
                               />
                               )}
                           />
                   </div>
                   </div>
               </div>
               <div className="w-full flex justify-between my-4">
                   <h5 className="text-gray-400 mr-12">Username:</h5>
                   <div className="">
                       <div className="flex text-xs lg:text-sm md:text-sm">
                       <p>{stellaState?.response?.Object?.UserName}</p>

                            {stellaState?.response?.Object?.UserName !== "No login details" &&
                            <div className="w-full">
                                    <CopyCod className="w-4 font-bold text-black mx-2" />
                                    <Controller
                                        name="username"
                                        control={control}
                                        defaultValue=""
                                        render={({ name, value, onChange }) => (
                                        <TextInput
                                            name={name}
                                            value={value}
                                            id={name}
                                            showCopy
                                            disabled
                                            className="border-gray-300"
                                            wrapperClassName="absolute -ml-36 opacity-0"
                                            // error={errors['zipcode']}
                                            // label="Zipcode"
                                            labelClassName=""
                                            placeholder=""
                                            customChange={onChange}
                                        />
                                        )}
                                    />
                            </div>
                              }
                       </div>
                   </div>
               </div>
               <div className="w-full flex justify-between my-4">
                   <h5 className="text-gray-400 mr-12">Password:</h5>
                   <div className="">
                   <div className="flex text-xs lg:text-sm md:text-sm">
                       <p>{stellaState?.response?.Object?.Password}</p>

                        {stellaState?.response?.Object?.Password !== "No login details" &&
                                <div className="w-full">
                                <CopyCod className="w-4 font-bold text-black mx-2" />
                                    <Controller
                                        name="password"
                                        control={control}
                                        defaultValue=""
                                        render={({ name, value, onChange }) => (
                                        <TextInput
                                            name={name}
                                            value={value}
                                            id={name}
                                            showCopy
                                            disabled
                                            className="border-gray-300"
                                            wrapperClassName="absolute -ml-36 opacity-0"
                                            // error={errors['zipcode']}
                                            // label="Zipcode"
                                            labelClassName=""
                                            placeholder=""
                                            customChange={onChange}
                                        />
                                    )}
                                />
                                </div>
                            }

                       </div>
                   </div>
               </div>

   </div>

        <button className="w-full bg-black font-medium text-sm font-bold rounded text-white py-3 my-4" type="button" 
        onClick={() => 
            showModal({
                component: 'CodAccountStatement',
                modalProps: {
                contentLabel: 'Account Statement',
                }
        })}>View Account Statement</button>
        </div>
        {/* } */}
     
           
        </div>
     
            }

    </div>
);
};

export default StellasAccountDetails;